import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpoints } from '../../../../environments/environment';
import { PixTransaction } from '../models/transaction.model';
import { PixDevolutionRequest } from '../models/devolution-request.mode';
import { Observable } from 'rxjs/Observable';
import { PixReceipt } from '../models/receipt.model';

@Injectable()
export class PixRefundService {
	private url = endpoints.pix;
	private transaction: PixTransaction;
	private pixDevolutionRequest: PixDevolutionRequest;
	private pixReceipt: PixReceipt;

	constructor(private http: HttpClient) { }

	postDevolution(model: PixDevolutionRequest): Observable<any> {
		return this.http.post<any>(`${this.url.refund}`, model);
	}

	setPixTransaction = (transaction: PixTransaction) => this.transaction = transaction;
	getPixTransaction = () => this.transaction;
	setPixDevolutionRequest = (pixDevolutionRequest: PixDevolutionRequest) => this.pixDevolutionRequest = pixDevolutionRequest;
	getPixDevolutionRequest = () => this.pixDevolutionRequest;
	setPixReceipt = (pixReceipt: PixReceipt) => this.pixReceipt = pixReceipt;
	getPixReceipt = () => this.pixReceipt;

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/refund/refund.service.ts